import { render, staticRenderFns } from "./SingleCardSkeleton.vue?vue&type=template&id=623a2dd8&"
import script from "./SingleCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./SingleCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports